import React from 'react'
import { Outlet } from 'react-router-dom'

// PublicRoute renders unauthenticated pages (login, etc.).
// Session state is managed server-side via httpOnly cookie; PrivateRoute handles
// redirection to /login for unauthenticated requests on protected routes.
function PublicRoute() {
  return <Outlet />
}

export default PublicRoute
